import { RawHtmlSection } from '../../types/graphql'

export const rawHtmlSection: RawHtmlSection = {
  __typename: 'RawHtmlSection',
  id: 'A',
  html: '<p style="background: aliceblue">Blue paragraph with <b>bold</b> bit.</p>',
}
